// @ts-nocheck
import { createTheme } from '@mui/material/styles';
import merge from 'lodash/merge';
import cloneDeep from 'lodash/cloneDeep';
import baseTheme from './base';

const LIGHT_THEME = {
  themeName: 'Light',
  palette: {
    mode: 'light',
    type: 'light',
    attributesForm: {
      label: '#565656',
      value: '#282828',
    },
    unlink: '#282828',
    primary: {
      main: '#0C3270', // Brand Blue/70 (Primary Blue)
      light: '#4D6EA6', // Brand Blue/50
      dark: '#071E43', // Brand Blue/100
      contrastText: '#FFFFFF',
      main1: '#0C3270',
    },
    secondary: {
      main: '#F4F4F4', // Grey/20
      light: '#F8F8F8', // Grey/10
      dark: '#E9E9E9', // Grey/30
      contrastText: '#1D1D1D',
    },
    menuHover: {
      main: '#F4F4F4',
    },
    selection: {
      main: '#E5EFFF',
      secondary: '#F4F4F5', //grey/30
      contrastText: '#1D1D1D',
    },
    backdrop: {
      main: '#F9FAFB', // Canvas/Backdrop color from Figma
    },
    // Brand Blue Scale (from Figma Color Guide)
    blue: {
      5: '#EAF2FF',
      10: '#E5EFFF',
      20: '#AEC9F6',
      30: '#8EABDB',
      40: '#6D8DC0',
      50: '#4D6EA6',
      60: '#2C508B',
      65: '#2B7FFF',
      70: '#0C3270', // Primary Blue (main)
      80: '#0A285A',
      90: '#0A285A',
      100: '#071E43',
      110: '#05142D',
      120: '#020A16',
    },
    kpiCard: {
      pulseIconColor: '#0C3270',
      backgroundColor: '#AEC9F6',
    },
    // Grey Scale (from Figma Color Guide)
    grey: {
      5: '#EEF2F7',
      10: '#F9F9F9',
      20: '#F8F8F8',
      30: '#F4F4F5',
      40: '#F4F4F4',
      50: '#E9E9E9',
      60: '#E3E6F0',
      70: '#D2D2D2',
      80: '#BCBCBC',
      T10: '#8F8F8F',
      T20: '#71717A',
      T30: '#565656',
      T40: '#535353',
      T50: '#393939',
      T60: '#282828',
      T70: '#1D1D1D',
      T80: '#09090B',
    },
    success: {
      10: '#ECFDF3',
      20: '#D1FADF',
      30: '#D2FADF', // Note: Figma shows #D2FADF for 30
      40: '#A6F4C5',
      50: '#6CE9A6',
      60: '#32D583',
      main: '#15803D', // 70
      70: '#12B76A',
      80: '#16A34A', // Note: Figma shows #16A34A for 80
      90: '#0AA302',
      100: '#039855',
      110: '#027A48',
      120: '#05603A',
      130: '#054F31',
      light: '#6CE9A6',
      dark: '#05603A',
      contrastText: '#FFFFFF',
    },
    error: {
      10: '#FEF3F2',
      20: '#FEE4E2',
      25: '#FFEEED',
      30: '#FECDCA',
      40: '#FDA29B',
      50: '#F97066',
      main: '#F04438', // 60
      60: '#F04438',
      70: '#D92D20',
      80: '#B42318', // Note: Figma also shows #DC2626 for 80
      90: '#912018',
      100: '#7A271A',
      light: '#FDA29B',
      dark: '#912018',
      contrastText: '#FFFFFF',
    },
    warning: {
      10: '#FFFAEB',
      20: '#FEF0C7',
      30: '#FEDF89',
      40: '#FEC84B',
      50: '#FDB022',
      main: '#F79009', // 60
      60: '#F79009',
      70: '#DC6803',
      80: '#B54708',
      90: '#93370D',
      100: '#7A271A',
      light: '#FEC84B',
      dark: '#93370D',
      contrastText: '#FFFFFF',
    },
    info: {
      main: '#29B6F6',
      light: '#4FC3F7',
      dark: '#0288D1',
      contrastText: '#000000',
    },
    lavenderBlue: {
      10: '#F2F2FF',
      20: '#E6E6FF',
      30: '#D6D9FF',
      40: '#C6CCFE',
      50: '#ACB9FD',
      60: '#97A8F8',
      70: '#818EEB',
      80: '#6975D9',
      90: '#4F59C0',
      100: '#3A3F9A',
    },
    // Orange Scale (from Figma Color Guide)
    orange: {
      10: '#FFF6F0',
      20: '#FEE1CD',
      30: '#FCC39C',
      40: '#FBA56A',
      50: '#FA8838',
      60: '#F97316',
      70: '#E56A14',
      80: '#DB6513',
      90: '#CC5E12',
      100: '#8D410C',
    },
    // Sky Blue Scale (from Figma Color Guide)
    skyBlue: {
      5: '#F8FAFC',
      10: '#E2ECFE',
      20: '#CEE0FD',
      25: '#D7EAFE',
      30: '#9DC1FB',
      40: '#6DA2F8',
      50: '#3B82F6',
      60: '#0B64F4',
      70: '#0950C3',
      80: '#073C92',
      90: '#042862',
      100: '#021431',
      icon: '#3B82F6',
    },
    background: {
      default: '#FFFFFF', // Section color
      paper: '#FFFFFF', // Grey/20 //F8F8F8
      infoBackground: '#EAF2FF', // for modal info box
      tableHeader: '#EFEFEF',
      default1: '#FFFFFF',
    },
    // Additional selection shades from Figma
    selectionShades: {
      sideMenu: '#E5EFFF',
      cardFill: '#FAFCFF',
      fieldSelect: '#F4F4F4',
    },
    other: {
      topNavIconColor: 'inherit',
      topNavSelectionBg: '#E4EEFF',
      appHeaderBorder: '#E2E4ED',
      appHeaderNavHover: '#F4F5FA',
      appHeaderIconHover: '#EFF0F6',
      appHeaderIconColor: '#3D4253',
      appHeaderShadow:
        '0 4px 16px rgba(0, 0, 0, 0.08), 0 1px 4px rgba(0, 0, 0, 0.04)',
      //  To Do: Below colors are extra, need to remove dependencies of these colors if required
      checkerBackgroundColor: '#FFFFFF',
      workflowConnectingEdgeColorDuringConnection: '#000000',
      workflowEdgeTextColor: ' #272D55',
      activityChartAreaColor: '#272D55',
      reactFlowBackgroundColor: '#F9F9F9',
      reactFlowBackgroundLinesColor: '#DFDFDF80',
      menuHover: '#F0F0F0',
      listTableRowSelectedBg: '#F0F0F0',
      badgeBorder: '#EE883D',
      lightBrandBlueLogin: '#84AFEF',
      white: '#FFFFFF',
      overdue: '#E74C3C',
      cell: '#FFFFFF',
      gradient1: 'linear-gradient(90deg, rgba(243,245,255,1) 0%, #F5FCFB 79%)',
      gradient2:
        'linear-gradient(269.82deg, #F5FCFB 57.25%, rgba(200, 222, 255, 0.1) 230.71%)',
      modelPriorityMedium: '#ffff00',
      statusQueued: '#FF9800',
      successBackgroundColor: '#EBFBF5',
      errorBackgroundColor: '#FDEDEF',
      /** HTML attribute upload dropzone (AddAttribute): subtle tint; keeps contrast vs success/error borders & icons */
      htmlAttributeUploadSuccessBg: '#EBFBF5',
      htmlAttributeUploadErrorBg: '#FDEDEF',
      successCheckIconBackground: '#35D39D',
      errorCheckIconBackground: '#EF4D61',
      decisionNodeBgColor: '#9CA8B3',
      decisionNodeLeftSourceHandleBgColor: '#EF4F0B',
      decisionNodeTargetTopHandleBgColor: '#0182FB',
      decisionNodeRightSourceHandleBgColor: '#F7EA00',
      processingNodeBgColor: '#4CAF50',
      processingNodeTopHandleBgColor: '#0182FB',
      processingNodeBottomHandleBgColor: '#F7EA00',
      terminalNodeBgColor: '#FF5722',
      startNodeBgColor: '#ff562262',
      startNodeBottomHandleBgColor: '#EF4F0B',
      nodesBoxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
      borderColor: '#D8DAE5',
      mentionModelTextColor: '#B74B52',
      threadTitle: '#2D2D2D',
      threadTagBackground: '#D4FFF9',
      nodeToolBgColor: '#272D55',
      startNodeBackgroundColor: '#C4DBFF',
      endNodeBackgroundColor: '#90EE90',
      startNodeBorderColor: '#3B82F6',
      endNodeBorderColor: '#4CAF50',
      defaultNodeBackgroundColor: '#ffffff',
      currentNodeBackground: '#013661',
      nodeBlackFontColor: '#000000',
      nodeWhiteFontColor: '#ffffff',
      // Table Attribute Schema Builder Colors
      hoverBackground: '#F1F3F4',
      editorBackground: '#FFFFFF',
      ruleEditorHover: '#EEEEEE',
      toolbarText: '#666666',
      editorHeaderText: '#212936',
      editorResizeHandle: '#999999',
      addIconColor: '#5F6368',
      // Adding editor-related colors
      editorBorder: '#E7E4E2',
      danger: '#F00000',
      lightText: '#111111',
      inputBackground: '#F5F5F5',
      // Shadow colors with transparency
      shadowLight: 'rgba(0, 0, 0, 0.13)',
      shadowLighter: 'rgba(0, 0, 0, 0.11)',
      AttributeCardColor: 'rgba(174, 205, 252, 0.4)',
      MasterFilterHeadBackgroundColor: '#EBEEFF',
      MasterFilterFontColor: '#0C3270',
      MasterFilterHoverBackgroundColor: '#F5F5F5',
      deleteIconBackgroundHomePageSetup: '#FFFFFF',
      calculationBgColor: ' #F4F4F4',
      calculateBorderColor: '#999999',
      infoBoxColor: '#D4DAFF',
      attachmentBorder: '#E3E6F0',
      // AI Autofill feature colors
      aiPrimary: '#8E55F9',
      aiPrimaryDark: '#7040D4',
      aiPrimaryLight: '#B388FC',
      aiPrimaryBg: '#F4EFFE',
      aiHighlightShadowBase: 'rgba(142, 85, 249, 0.25)',
      aiHighlightShadowStrong: 'rgba(142, 85, 249, 0.35)',
      aiHighlightShadowMedium: 'rgba(142, 85, 249, 0.30)',
      aiHighlightShadowSoft: 'rgba(142, 85, 249, 0.20)',
      aiHighlightBackgroundBase: 'rgba(142, 85, 249, 0.08)',
      aiHighlightBackgroundSubtle: 'rgba(142, 85, 249, 0.05)',
      aiHighlightBackgroundStrong: 'rgba(142, 85, 249, 0.12)',
      aiHighlightBackgroundMedium: 'rgba(142, 85, 249, 0.10)',
      aiHighlightBackgroundSoft: 'rgba(142, 85, 249, 0.06)',
      aiHighlightBackgroundFaint: 'rgba(142, 85, 249, 0.02)',
      aiPrimaryText: '#8E55F9',
      aiPrimaryButtonText: '#FFFFFF',
      badgeBg: '#ECECEC',
      badgeText: '#6A7282',
      brandBlue: '#0C3270',
      jobCountBG: '#272D55',
      jobCount: '#FFFFFF',
      filterDrawerBackground: '#D9D9D9',
      filterCardStroke: '#D8DAE5',
      filterCardFill: '#FFFFFF',
      filterCardHover: '#F4F4F4',
      filterCardActiveFill: '#F4F4F4',
      filterResetBorder: '#0c327080',
      filterTabsBorder: '#F4F4F4',
      filterTabsBackground: '#F4F4F4',
    },
    examinationResults: {
      guidelineIconBg: 'rgba(251, 190, 118, 0.08)',
      confidenceGreen: '#058234',
      confidenceAmber: '#D08329',
      severityCritical: '#B3261E',
      severityHigh: '#C66A00',
      severityMedium: '#D08329',
      severityLow: '#0C6B58',
      overallStrong: '#058234',
      overallMedium: '#D08329',
      overallWeak: '#E32B2B',
      verdictReady: '#058234',
      verdictNotReady: '#E32B2B',
      sidebarActiveBg: '#E4EEFF',
      sidebarInactiveBg: '#F7F8FB',
      sidebarText: '#282828',
      categoryBadgeBg: '#F4F6FD',
      categoryBadgeText: '#272D55',
      border: '#D8DAE5',
      severityCriticalBg: '#FDEDEF',
      severityHighBg: '#FFF0DD',
      severityMediumBg: '#FFF7E6',
      severityLowBg: '#EAFBF4',
      ratingStrongBg: '#EBFBF5',
      ratingMediumBg: '#FFF7E6',
      ratingWeakBg: '#FDEDEF',
      verdictReadyBg: '#EBFBF5',
      verdictNotReadyBg: '#FDEDEF',
      findingsIconBg: '#E0F2FE',
      findingsIconColor: '#075985',
    },
    draft: {
      // Draft field accent colors
      accent: '#CE8100',
      border: '#F59E0B',
      rowBg: '#FFFBF0',
      inputBg: '#FFFAEB',
      iconColor: '#6F6F6F',
      // Draft editor avatar colors (per-user colors in co-editing)
      editorAvatarColor0: '#00897B',
      editorAvatarColor1: '#FB8C00',
      editorAvatarColor2: '#8E24AA',
      // History drawer avatar backgrounds
      historyAvatarBg0: '#0C3270',
      historyAvatarBg1: '#006E28',
      historyAvatarBg2: '#F59E0B',
      // History drawer timeline nodes
      historyTimelineActive: '#4B7BFF',
      historyTimelineInactive: '#9E9E9E',
      // History drawer diff chip backgrounds
      historyDiffAddedBg: '#CCFFDF',
      historyDiffEditedBg: '#FEF0C7',
      historyDiffEditedColor: '#B54708',
      historyDiffRemovedBg: '#FEF6F6',
      historyDiffRemovedColor: '#DC2626',
    },
    dynamicBarChart: {
      barColor: '#ACB9FD',
      textColor: '#282828',
      gridLineColor: '#E8E8E8',
    },
    landScapeLegendOtherColors: {
      legend1: '#EE9023',
      legend2: '#ACB9FD',
      legend3: '#F4B2B6',
      legend4: '#F9BCE4',
      legend5: '#EBF0B1',
      legend6: '#D4BCF2',
      legend7: '#DEF0B8',
      legend8: '#B3F0F0',
      legend9: '#645FE4',
    },
    landscape: {
      mainNode: '#E4EEFF',
      model: '#0C3270',
      artifact: '#05603A',
      useCase: '#D96144',
      assessment: '#F79009',
      query: '#4F39F6',
      attribute: '#DA70D6',
      bg: {
        main: '#FFFFFF',
        model: '#AEC9F6',
        artifact: '#D1FADF',
        useCase: '#FEE4E2',
        query: '#C8C1FF',
        assessment: '#FEF0C7',
        attribute: '#AEAEAE',
        accessRequest: '#E5EFFF',
      },
      // ReactFlow node handles and default edge stroke
      handleColor: '#C1C1C1',
      // Selected item background in cluster-node entity dropdown
      menuItemSelected: '#F1F1F1',
      // Muted icon color (e.g. linked_entity_count icon)
      iconMuted: '#CACACA',
      // Relation tooltip label color
      tooltipLabelColor: '#616E85',
      // Entity cluster-node menu item hover / selected background
      entityMenuItemHover: '#F4F4F5',
      // Lineage node handle color (primary.main at 60% opacity)
      lineageHandleColor: 'rgba(12, 50, 112, 0.6)',
      // Deterministic dot colors for cluster nodes in the landscape view
      nodeDotColors: [
        '#4C9BE8',
        '#F59E0B',
        '#10B981',
        '#8B5CF6',
        '#EF4444',
        '#06B6D4',
        '#F97316',
        '#84CC16',
        '#EC4899',
        '#6366F1',
      ],
    },
    entityTypeEditor: {
      cardBackground: '#FFFFFF',
      cardBorder: '#EEF2F6',
      cardDivider: '#E6EAF2',
      previewBorder: '#D8DAE5',
      previewBackground: '#FFFFFF',
      dropzoneBorder: '#D8DEEA',
      dropzoneHoverBackground: '#F5F8FF',
      layoutButtonBackground: '#FFFFFF',
      layoutButtonSelectedBackground: '#D8E7FF',
      tabIndicator: '#282828',
      predefinedIconBackground: '#DCFCE7',
      predefinedIconColor: '#15803D',
    },
    summaryCardQueryColors: {
      open: '#DBEAFE',
      AcknowlegeQuery: '#F3E8FF',
      inReview: '#FFE2E2',
      closed: '#DCFCE7',
    },
    queryStatus: {
      open: '#175CD3',
      draftResponse: '#344054',
      draft: '#344054',
      waive: '#0A5E2A',
      revisionRequested: '#5B2C91',
      closed: '#FFFFFF',
      responseReceived: '#8B2C00',
      inReview: '#003366',
      bg: {
        open: '#EFF8FF',
        draft: '#F2F4F7',
        draftResponse: '#F2F4F7',
        waive: '#BFFCC6',
        revisionRequested: '#E2D4F7',
        responseReceived: '#FFD2A6',
        closed: '#16A34A',
        inReview: '#B8E1FF',
      },
    },
    actionsQueryStatus: {
      act: '#393939',
      actButton: '#282E52',
      border: '#292C56',
    },
    queryFilter: {
      color: '#09090B',
      bgcolor: '#FFFFFF',
    },
    queryDialog: {
      title: '#1E293B',
      subtitle: '#667085',
      closeIcon: '#98A2B3',
      panelBackground: '#F8FAFC',
      panelBorder: '#E2E8F0',
      inputBackground: '#FFFFFF',
      actionBorder: '#0C3270',

      bannerBg: '#EAF2FF',
      bannerBorder: '#B8D4FE',
      accordionHeaderBg: '#F3F3F3',
      accordionHeaderBorder: '#E3E6F0',
      ChangeStatus: '#414141',
    },
    queryTitle: {
      color: '#2E2E2E',
    },
    historyTimeLine: {
      line: '#272D55',
      updatedText: '#616161',
      activeDot: '#1976D2',
      inactiveDot: '#848484',
      objectKey: '#565656',
      objecetVal: '#282828',
    },
    actionable: {
      // Actionable workflow node
      actionableNodeBg: '#F9F9F9',
      actionableNodeBorder: '#CACACA',
      actionableNodeText: '#666666',
      actionableNodeDotBg: '#666666',
      actionableSelectedNodeBg: '#D8E7FF',
      actionableSelectedNodeBorder: '#0C3270',
      actionableSelectedNodeText: '#0C3270',
      actionableDetailsLabelText: '#6A7282',
      actionableDetailsItemBorder: '#E3E6F0',
      actionableDetailsItemPathText: '#4A5565',
    },

    mentionsInChatEntityColor: {
      attributeNode: '#527EB7',
      model: '#B74B52',
      artifact: '#272D55',
      document: '#B78D52',
      userName: '#003F6B',
      hoverTextColor: '#FFFFFF',
      background: '#CEE2FF',
      textColor: '#272D55',
    },
    draftjsPopover: {
      mentionSuggestions: {
        borderColor: '#D8DAE5',
        backgroundColor: '#F1F3F4',
      },
      mentionSuggestionsEntryFocused: {
        backgroundColor: '#272d5533',
      },
    },
    text: {
      primary: '#282828', // Grey/T60
      secondary: '#535353', // Grey/T40
      disabled: '#8F8F8F', // Grey/T10
      // To Do: Below colors are extra, need to remove dependencies of these colors if required
      contrastText: '#1A1A1A',
      placeholder: '#525252',
      light: '#FFFFFF',
      light1: '#EAEAEA',
      dark: '#000000',
      manual: '#2196f3',
      automation: '#4CAF50',
      calculated: '#9C27B0',
      overridden: '#C3000D',
      default: '#212936',
    },
    compareVersion: {
      added: {
        bgColor: '#e8f5e9',
        borderColor: '#a5d6a7',
      },
      removed: {
        bgColor: '#ffebee',
        borderColor: '#ef9a9a',
      },
      modified: {
        bgColor: '#fff8e1',
        borderColor: '#ffe082',
      },
      versionHeader: '#E3ECFF',
    },
    notificationBanner: {
      background: '#FFFBD7',
    },
    documentLinkedEntities: {
      titleText: '#31395E',
      warningBackground: '#FEF0C7',
      borderColor: '#E0E0E0',
    },
    layout: {
      backgroundColor: '#F9F9F9',
    },
    transitionHistoryStatusColors: {
      success: '#4CAF50',
      failed: '#F44336',
      partiallySuccessful: '#FF9800',
      default: '#000000',
    },
    entityColor: {
      model: '#B74B52',
      artifact: '#272D55',
      artifactLandscapeView: '#FFFFFF',
      assessment: '#4caf50',
      useCase: '#2196f3',
      accessRequest: '#272D55',
      query: '#4F39F6',
      globalAttributes: '#E5E8FA',
      background: {
        model: '#E7B1B5',
        artifact: '#8A8EAF',
        assessment: '#A5E0A7',
        useCase: '#90CAF9',
        accessRequest: '#8A8EAF',
        globalAttributes: '#F4F6FD',
        popOverMenuBG: '#E5E8FA',
      },
      artifactSubColor: {
        level1: '#966E2F',
        level2: '#F39C12',
        level3: '#F78C6B',
        default: '#272D55',
      },
    },
    sseNotification: {
      successIconColor: '#52BE7F',
      failedIconColor: '#EB5757',
      partialIconColor: '#FF9800',
      pendingIconColor: '#BDBDBD',
    },
    aiAutofillNotification: {
      inProgressHeaderBg: '#6A3BC7',
      completedHeaderBg: '#1B5E20',
      failedHeaderBg: '#B71C1C',
      headerTextColor: '#FFFFFF',
      bodyBg: '#FFFFFF',
      subtitleColor: '#757575',
      progressTrackColor: '#D1C4E9',
      progressBarColor: '#8E55F9',
      inProgressIconBg: '#F4EFFE',
      completedIconBg: '#E8F5E9',
      failedIconBg: '#FFEBEE',
      inProgressIconColor: '#8E55F9',
      completedIconColor: '#2E7D32',
      failedIconColor: '#C62828',
      viewSuggestionsButtonBg: '#8E55F9',
      viewSuggestionsButtonHoverBg: '#7040D4',
    },
    AINotification: {
      inProgressHeaderBg: '#8E55F9',
      completedHeaderBg: '#1B5E20',
      failedHeaderBg: '#B71C1C',
      headerTextColor: '#FFFFFF',
      bodyBg: '#FFFFFF',
      subtitleColor: '#757575',
      progressTrackColor: '#C5CAE9',
      progressBarColor: '#AECDFC',
      inProgressIconBg: '#E8EAF6',
      completedIconBg: '#E8F5E9',
      failedIconBg: '#FFEBEE',
      inProgressIconColor: '#272D55',
      completedIconColor: '#2E7D32',
      failedIconColor: '#C62828',
    },
    regulatoryMapper: {
      warningMain: '#FE9A00',
      warningBg: '#FFFBEB',
    },
    monacoEditor: {
      colors: {
        'editor.foreground': '#272D55',
        'editor.background': '#FFFFFF',
        'editorCursor.foreground': '#272D55',
        'editor.lineHighlightBackground': '#F5F5F5',
        'editorLineNumber.foreground': '#AECDFC80',
        'editorLineNumber.activeForeground': '#272D55',
        'editor.selectionBackground': '#AECDFC50',
        'editor.inactiveSelectionBackground': '#AECDFC30',
        'editorGutter.background': '#F5F5F5',
        'scrollbarSlider.background': '#AECDFC80',
        'scrollbarSlider.hoverBackground': '#84AFEF80',
        'scrollbarSlider.activeBackground': '#272D5580',
      },
      derivedFormulaEditor: {
        colors: {
          'editor.background': '#FFFFFF',
          'editorLineNumber.foreground': '#AAAAAA',
          'editorCursor.foreground': '#000000',
          'editor.foreground': '#272D55',
          'editor.lineHighlightBackground': '#F5F5F5',
          'editor.selectionBackground': '#AECDFC50',
          'editor.inactiveSelectionBackground': '#AECDFC30',
          'editorGutter.background': '#F5F5F5',
          'scrollbarSlider.background': '#AECDFC80',
          'scrollbarSlider.hoverBackground': '#84AFEF80',
          'scrollbarSlider.activeBackground': '#272D5580',
        },
        tokenColors: {
          'formula-block': '#A020F0',
          comment: '#888888',
          string: '#008000',
          keyword: '#0000FF',
          number: '#098658',
          variable: '#B8860B',
          identifier: '#222222',
        },
      },
    },
    divider: '#E3E6F0', // Grey/30
    contextMenu: {
      menu: {
        '--contexify-menu-bgColor': '#FFFFFF',
        '--contexify-item-color': '#272D55',
        '--contexify-activeItem-bgColor': '#F5F5F5',
        '--contexify-activeItem-color': '#272D55',
        '--contexify-arrow-color': '#6F6E77',
        '--contexify-activeArrow-color': '#272D55',
        '--contexify-rightSlot-color': '#6F6E77',
        '--contexify-activeRightSlot-color': '#272D55',
        '--contexify-separator-color': '#E3E6F0',
      },
    },
    solyticsFlow: {
      node: {
        defaultBg: '#FFFFFF',
        defaultBorder: '#E3E6F0',
        defaultText: '#09090B',
        primaryBg: '#E5EFFF',
        primaryBorder: '#AEC9F6',
        primaryText: '#0C3270',
        dangerBg: '#FEF3F2',
        dangerBorder: '#FECDCA',
        dangerText: '#D92D20',
        infoBg: '#E5EFFF',
        infoBorder: '#AEC9F6',
        infoText: '#0C3270',
        groupBg: 'rgba(227, 242, 253, 0.3)',
        groupBorder: '#9DC1FB',
        groupText: '#0C3270',
        handleColor: '#BCBCBC',
      },
      edge: {
        defaultStroke: '#09090B',
        mutedStroke: '#393939',
        labelColor: '#71717A',
      },
      canvas: {
        dotColor: '#E4E4E7',
        minimapBorder: '#E4E4E7',
      },
    },
    // ColorPicker palette colors
    colorPicker: {
      black: '#000000',
      darkGray: '#434343',
      mediumGray: '#666666',
      gray: '#999999',
      lightGray: '#b7b7b7',
      lighterGray: '#cccccc',
      lightestGray: '#d9d9d9',
      nearWhite: '#efefef',
      offWhite: '#f3f3f3',
      white: '#ffffff',
      darkRed: '#980000',
      red: '#ff0000',
      orange: '#ff9900',
      yellow: '#ffff00',
      green: '#00ff00',
      cyan: '#00ffff',
      blue: '#4a86e8',
      brightBlue: '#0000ff',
      purple: '#9900ff',
      magenta: '#ff00ff',
    },
    lifeCycleWorkflow: {
      workflowActiveNodeBg: '#272D55',
      workflowActiveNodeText: '#FFFFFF',
      workflowNodeBorder: '#272D55',
      highlightedEdgeColor: '#272D55',
      edgeTextColor: '#272D55',
      highlightedEdgeBackground: '#AECDFC',
      completedNodeBg: '#16A34A',
      completedNodeBorder: '#16A34A',
      completedNodeText: '#FFFFFF',
      currentNodeBg: '#F59E0B',
      currentNodeBorder: '#F59E0B',
      currentNodeText: '#FFFFFF',
      pendingNodeBg: '#F9F9F9',
      pendingNodeBorder: '#CACACA',
      pendingNodeText: '#374151',
    },
    workflowGroups: {
      complete: '#16A34A',
      ongoing: '#3B82F6',
      pending: '#F97316',
      groupNodeBg: '#D0E3FF',
    },
    loginPage: {
      background: '#FFFFFF',
      loginFormBorder: '#E5E7EB',
    },
    advanceFilters: {
      combinatorButtonBackgroundColorAdvTab: '#F4F4F4',
      selectedCombinatorButtonBackgroundColorAdvTab: '#FFFFFF',
      advanceBlockHeaderColor: '#EAF2FF',
      combinatorTextColor: '#555555',
      defaultTextColor: '#535353',
      countBackgroundColor: '#0C3270',
      buttonBorderColor: '#BCBCBC',
      borderRightBasicTab: '#E9E9E9',
      selectedLeftFieldBackground: '#E8F0FE',
      hoverLeftFieldBackground: '#F9F9F9',
      iconHoverColor: '#F0F0F0',
      andOrBoxShadow: 'rgba(255, 255, 255, 1)',
      groupBorder: '#E4E4E7',
      iconColor: '#09090B',
      whiteTextColor: '#FFFFFF',
      textColor: '#FFFFFF',
      hoveringCountBackgroundColor: '#0C3270',
      selectedHoverFieldBackground: '#0C3270',
    },
    // Log Filter
    logFilters: {
      linkColor: '#272D55',
      borderColor: '#E0E0E0',
      LogModuleBackgroundColor: '#E3E3E3',
      fontColor: '#282828',
    },
    archivedBanner: {
      fontColor: '#282828',
      iconColor: '#272D55',
      bannerBackgroundColor: '#FFF8E1',
      bannerBorderColor: '#FFE082',
    },
    tableWrapper: {
      backgroundColor: '#FFFFFF',
      borderColor: '#E3E6F0',
      headerBorderColor: 'E3E6F0',
    },
    uploadProgress: {
      success: '#4DB77D',
      headerTitle: '#1A237E',
      headerBg: '#F5F5F5',
      border: '#0000001A',
      progressWheelBackground: '#0000001A',
      boxShadow: '0px 8px 24px #00000026',
    },
    //Entity Overview
    entityOverview: {
      accordionExpand: '#E5EFFF',
      accordionCollapse: '#EEEDF2',
      accordionSelected: '#E5EFFF',
      borderLfetTightPanel: '#E0E0E0',
      IconColor: '#000000',
      accordionTitleBackground: '#FFFFFF',
      dividerBorder: '#CACACA',
      headerText: '#393939',
    },
    vaultChat: {
      color: '#A4A4A4',
    },
    actionablesColor: {
      background: {
        low: '#FFFBE9',
        high: '#FFEBEB',
        medium: '#FFF4C9',
        completed: '#E0FFE9',
      },
      iconColor: '#99A1AF',
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        '*': {
          '&::-webkit-scrollbar-thumb': {
            background: '#CACACA',
          },
          '&:hover::-webkit-scrollbar-thumb': {
            backgroundColor: 'rgba(0, 0, 0, 0.3)',
          },
        },
        '.hover-scrollbar.is-visible::-webkit-scrollbar-thumb': {
          background: '#CACACA',
        },
        '@keyframes linkedEntityBtnPulse': {
          '50%': {
            boxShadow: '0 0 14px 4px #FEC84B',
          },
        },
        // React Query Builder specific styles for light theme
        '.ruleGroup': {
          borderColor: '#767575 !important',
          backgroundColor: '#F4F4F4 !important',
        },
        '.ruleGroup .rule': {
          backgroundColor: '#F4F4F4 !important',
        },
        '.ruleGroupSimple .ruleSimple': {
          backgroundColor: '#FFFFFF !important',
        },
        '.ruleGroup .rule-value': { backgroundColor: '#FFFFFF !important' },
        '.ruleGroup .rule-fields': { backgroundColor: '#FFFFFF !important' },
        '.ruleGroup .rule-operators': { backgroundColor: '#FFFFFF !important' },
        '.advance-query-builder': {
          '& .ruleGroupAdvance': {
            backgroundColor: '#F4F4F4 !important',
          },
        },
        '.conditional-query-builder': {
          '& .conditionalRuleGroup': {
            backgroundColor: 'transparent !important',
          },
        },

        '.custom-link:focus-visible': {
          outline: '2px solid #272D55',
        },
        '.table-card-wrapper': {
          backgroundColor: '#FFFFFF',
          border: '1px solid #E3E6F0',
        },
        '.query-dialog-form-container': {
          backgroundColor: '#F3F3F3',
          border: '1px solid #E2E8F0',
          borderRadius: '12px',
          padding: '20px 16px',
          '@media (min-width: 900px)': {
            paddingLeft: '20px',
            paddingRight: '20px',
          },
          '& .MuiOutlinedInput-root': {
            backgroundColor: '#FFFFFF',
            borderRadius: '6px',
          },
          '& .summary-card': {
            backgroundColor: 'transparent !important',
            borderRadius: '0 !important',
            padding: '0 !important',
            boxShadow: 'none !important',
            margin: '0 -8px !important',
            width: 'calc(100% + 16px) !important',
            maxWidth: 'calc(100% + 16px) !important',
          },
          '& .MuiFormHelperText-root': {
            marginLeft: 0,
            marginTop: '6px',
          },
        },
        '.ai-autofill-notification': {
          '& .title': {
            color: '#FFFFFF',
          },
          '& .title.in-progress': {
            backgroundColor: '#6A3BC7',
          },
          '& .title.completed': {
            backgroundColor: '#1B5E20',
          },
          '& .title.failed': {
            backgroundColor: '#B71C1C',
          },
          '& .body': {
            backgroundColor: '#FFFFFF',
          },
          '& .actions': {
            backgroundColor: '#FFFFFF',
          },
          '& .subtitle': {
            color: '#757575',
          },
          '& .icon.in-progress': {
            backgroundColor: '#F4EFFE',
            color: '#8E55F9',
          },
          '& .icon.completed': {
            backgroundColor: '#E8F5E9',
            color: '#2E7D32',
          },
          '& .icon.failed': {
            backgroundColor: '#FFEBEE',
            color: '#C62828',
          },
          '& .progress': {
            backgroundColor: '#D1C4E9',
          },
          '& .progress .MuiLinearProgress-bar': {
            backgroundColor: '#8E55F9',
          },
          '& .dismiss': {
            color: '#FFFFFF',
            '&:hover': {
              backgroundColor: 'rgba(255, 255, 255, 0.14)',
            },
          },
          '& .actions .action.in-progress': {
            borderColor: '#8E55F9',
            color: '#8E55F9',
          },
          '& .actions .action.view-suggestions': {
            backgroundColor: '#8E55F9',
            color: '#FFFFFF',
            '&:hover': {
              backgroundColor: '#7040D4',
            },
          },
          '& .actions .action.retry': {
            backgroundColor: '#E32B2B',
            color: '#FFFFFF',
            '&:hover': {
              backgroundColor: '#A43C3C',
            },
          },
        },

        '&:hover .leftFieldCount': {
          backgroundColor: '#0C3270',
          color: '#FFFFFF',
        },
        '&:hover .leftFieldIcon': {
          color: '#0C3270',
        },
        html: {
          // Table resizer styles
          '& .resizer': {
            backgroundColor: 'transparent !important',
            color: '#CACACA',
            '&.isResizing': {
              color: '#CACACA',
            },
          },
        },
        '.contexify': {
          boxShadow: `0px 4px 16px rgba(39, 45, 85, 0.08)`,
          border: '1px solid #E3E6F0',
        },
        '.contexify_itemContent': {
          color: 'var(--contexify-item-color, #272D55)',
        },
        '.editor-toolbar': {
          display: 'flex',
          alignItems: 'start',
          minHeight: '40px',
        },
        // tip tap editor styles
        ':root': {},

        '.light-theme .mdxeditor-toolbar button[data-toolbar-item="true"]': {
          backgroundColor: '#FFFFFF !important',
          color: '#272D55 !important',
          border: '1px solid #FFFFFF !important',
        },
        '.light-theme .mdxeditor-toolbar button[data-toolbar-item="true"]:hover':
          {
            backgroundColor: '#F4F4F4 !important',
          },
        // Dropdown content
        '.light-theme .mdxeditor-select-content': {
          backgroundColor: '#FFFFFF !important',
          border: '1px solid #CACACA !important',
          boxShadow: '0px 4px 12px rgba(39, 45, 85, 0.15) !important',
        },
        '.light-theme .mdxeditor-select-content .mdxeditor-select-viewport': {
          backgroundColor: '#FFFFFF !important',
        },
        // Dropdown items
        '.light-theme .mdxeditor-select-item': {
          backgroundColor: '#FFFFFF !important',
          color: '#272D55 !important',
          padding: '8px 12px !important',
        },
        '.light-theme .mdxeditor-select-item[data-highlighted]': {
          backgroundColor: '#E8F0FE !important',
          color: '#000000 !important',
          outline: 'none !important',
        },
        'body:has(.light-theme) .mdxeditor-popup-container .mdxeditor-select-content':
          {
            backgroundColor: '#FFFFFF !important',
            border: '1px solid #CACACA !important',
            boxShadow: '0px 4px 12px rgba(39, 45, 85, 0.15) !important',
          },
        'body:has(.light-theme) .mdxeditor-popup-container .mdxeditor-select-item':
          {
            backgroundColor: '#FFFFFF !important',
            color: '#272D55 !important',
          },
        'body:has(.light-theme) .mdxeditor-popup-container .mdxeditor-select-item[data-highlighted]':
          {
            backgroundColor: '#E8F0FE !important',
            color: '#000000 !important',
          },

        '.tiptap pre': {
          background: '#000000',
          color: '#FFFFFF',
        },
        '.tiptap code': {
          backgroundColor: '#F6F2FF',
          color: '#000000',
        },
        '.tiptap blockquote': {
          borderLeft: '3px solid #0BB7A7',
        },
        '.tiptap hr': {
          borderTop: '1px solid #0BB7A7',
        },
        '.tiptap img.ProseMirror-selectednode': {
          outline: '3px solid #0BB7A7',
        },
        '.tiptap td, .tiptap th': {
          border: '1px solid #E7E4E2',
        },
        '.tiptap th': {
          backgroundColor: '#F5F4F3',
        },
        '.tiptap .selectedCell::after': {
          background: '#0BB7A720',
        },
        '.tiptap .column-resize-handle': {
          backgroundColor: '#0BB7A7',
        },
        '.tiptap table[data-border="hidden"] td': {
          border: 'none',
        },
        '.tiptap table[data-border="hidden"] th': {
          border: 'none',
        },
        '.tiptap p.is-editor-empty:first-child::before': {
          color: '#ADB5BD',
        },
        // Table schema resize handler styles
        '.resize-handle::after': {
          borderColor: '#1A73E8 !important',
        },
        '.resize-handle:hover': {
          backgroundColor: 'rgba(26, 115, 232, 0.4)',
        },
        '.resize-handle:active': {
          backgroundColor: 'rgba(26, 115, 232, 0.4)',
        },
        '.account-id-form': {
          backgroundColor: '#FFFFFF',
        },
        '.login-form': {
          backgroundColor: '#FFFFFF',
        },
        // RichEditor specific styles
        '& .RichEditor-editor .RichEditor-blockquote': {
          borderLeft: `5px solid #FFFFFF`,
          color: '#666',
        },
        '& .RichEditor-editor .public-DraftStyleDefault-pre': {
          backgroundColor: 'rgba(0, 0, 0, 0.05)',
        },

        '& .RichEditor-styleButton': {
          color: '#999',
        },
        '& .RichEditor-activeButton': {
          color: '#5890FF',
        },
        '.RichEditorOuterBox': {
          '&.read-only': {
            border: 'none',
          },
          '&.edit-only': {
            border: '1px solid #DDD',
          },
        },

        // statusPlaning
        '.statusTaskCardColumn': {
          backgroundColor: '#F9F9F9',
          border: '1px solid #E0E6F1',
        },
        '.statusPlanningTemplateDetails': {
          backgroundColor: '#FFFFFF',
        },
        '.statusTaskCardColumnHeader': {
          backgroundColor: '#E5EFFF',
        },
        '.statusTaskCardColumnHeaderText': {
          color: '#000000',
        },
        '.statusTaskCardLabel': {
          fontFamily: 'inter',
          color: '#616E85',
        },
        '.statusTaskCard': {
          background: '#FFFFFF',
          border: '0.5px solid #D6D6D6',
          boxShadow: `0px 0.8px 1.8px 0px ${'rgba(0, 0, 0, 0.13)'},0px 0.15px 0.45px 0px ${'rgba(0, 0, 0, 0.11)'}`,
          '&:hover': {
            background: '#F1FFFD',
          },
        },
        '.statusTaskCardAvatar': {
          backgroundColor: '#F8EACD !important',
          color: '#7E5C0A !important',
        },

        //ReportCategory Table Accordian
        '.tableAccordionChip': {
          backgroundColor: '#E5EFFF !important',
          color: '#000000 !important',
        },

        '.tableAccordionList': {
          borderColor: '#8F8F8F !important',
        },

        // Bulk actions
        '.bulk-container': {
          border: '1px solid #272D55',
          background: '#FFFFFF',
        },
        // Document template upload
        '.dropzone': {
          border: '1px dashed #272D55',
          background: '#FFFFFF',
        },
        '.dropzone-error': {
          border: '2px dashed #EB5757',
          background: '#FFFFFF',
        },
        // Help and support article card
        '.help-support-article-card': {
          ':hover': {
            backgroundColor: 'rgba(39, 45, 85, 0.2)',
            borderColor: '#272D55',
          },
        },
        '.renderRowSubComponent': {
          backgroundColor: '#FFFFFF',
          '&.MuiTableRow-root': {
            backgroundColor: '#FFFFFF !important', // Added !important
            '&:hover': {
              backgroundColor: '#FFFFFF !important', // Added hover background color
            },
          },
        },
        // Theme and appearance
        '.uploadedLogoPreview': {
          border: `1px dashed #272D55 !important`,
          borderRadius: '4px',
          backgroundColor: '#F4F4F4',
        },
        '.logoDropzone': {
          border: `1px dashed #9396AA`,
          backgroundColor: '#FFFFFF',
          outline: 'none',
          '&:focus': {
            borderColor: '#272D55',
          },
          '&.text': {
            color: '#666',
          },
        },
        // Upload document attribute sharepoint
        '.upload-document-attribute': {
          border: `2px dashed #272D55`,
        },
        // Alerts drawer list
        '.alert-drawer-list': {
          '&:hover': {
            background: '#F0F0F0',
          },
          '&:focus-visible': {
            background: '#F0F0F0',
          },
        },
        // Approval list
        '.approval-list': {
          '&:hover': {
            background: '#F0F0F0',
          },
          '&:focus-visible': {
            background: '#F0F0F0',
          },
        },
        //  Permission Buttons
        '.permissionButtons': {
          '&.active': {
            color: '#272D55',
          },
          '&.inactive': {
            color: '#9396AA',
          },
        },
        '.disabledTextColor': {
          color: '#9396AA',
        },
        '.infoTextStyle': {
          color: '#0052CC',
        },
        // Automation
        '.automation-action-component, .automation-trigger-component, .automation-condition-component, .automation-loop-component':
          {
            border: '1px solid #E3E6F0',
            backgroundColor: '#FFFFFF',
            color: '#282828',
            '&.active, &:hover': {
              borderColor: '#E3E6F0',
              backgroundColor: 'rgba(39, 45, 85, 0.2)',
            },
          },
        '.automation-workflow-canvas .automation-action-component, .automation-workflow-canvas .automation-trigger-component, .automation-workflow-canvas .automation-condition-component, .automation-workflow-canvas .automation-loop-component':
          {
            border: '1px solid #E3E6F0',
            '&.active, &:hover': {
              borderColor: '#E3E6F0',
            },
          },
        '.automation-action-component.is-dragging': {
          backgroundColor: '#F4F4F5',
        },
        '.automation-node-icon': {
          backgroundColor: '#0C3270',
          color: '#FFFFFF',
        },
        '.automation-node-title': {
          color: '#0C3270',
        },
        '.automation-node-description, .automation-node-icon-button': {
          color: '#535353',
        },
        // chatbot
        '.citationBox': {
          backgroundColor: '#F4F4F4',
          '&.text': {
            color: '#000000',
          },
        },
        '.messageBox': {
          '&.isUser': {
            backgroundColor: '#E7EAFF',
          },
          '&.error': {
            backgroundColor: '#EB5757',
          },
          '&.other': {
            backgroundColor: '#F4F6FB',
          },
        },

        '.typeFilterChip': {
          backgroundColor: 'transparent !important',
          padding: '12px',
          border: '1px solid rgb(39, 45, 85);',
          borderRadius: '4px',
          '&.isOpen': {
            backgroundColor: '#9396AA',
          },
          '&:focus-visible': {
            outline: `2px solid #272D55`,
          },
        },
        '.logFilterChip, .MuiButtonBase-root.logFilterChip': {
          backgroundColor: 'transparent !important',
          border: '1px solid rgb(39, 45, 85) !important',
          borderRadius: '4px',
          '&.isOpen': {
            backgroundColor: '#9396AA',
          },
          '&:focus-visible': {
            outline: `2px solid #272D55`,
          },
        },

        // EffortPlaning
        '.effortPlaningLeftPanel': {
          borderRight: `1px solid #F4F4F4`,
        },
        '.userCard': {
          '&.isSelected': {
            backgroundColor: '#AECDFC',
          },
          background: '#FFFFFF',
          '&:hover': {
            background: '#F1F3F4',
          },
        },
        '.taskCard': {
          background: '#FFFFFF',
          '&:hover': {
            background: '#F1F3F4',
          },
        },

        // ActivityCalender
        '.toolbar': {
          '& .button': {
            backgroundColor: '#F4F4F4',
            color: '#272D55',
            '&:hover': {
              backgroundColor: '#F1F3F4',
            },
            '& .toolButton': {
              '&.selected': {
                color: '#272D55',
              },
              color: '#AECDFC',
            },
          },
        },
        // DraggableErrorDialog
        '.draggable-error-dialog': {
          '& .dialog-box': {
            backgroundColor: '#FFFFFF',
            border: '1px solid #E0E0E0',
            '& .dialog-title': {
              backgroundColor: '#D32F2F',
              color: '#FFFFFF',
              '& .dialog-title-text': {
                color: '#FFFFFF',
              },
              '& .dialog-close-button': {
                color: '#FFFFFF',
              },
            },
          },
        },
        // Draggable List Item
        'li.draggable-list-item': {
          borderColor: '#E0E0E0',
          backgroundColor: '#FFFFFF',
          '&:hover': {
            backgroundColor: '#FAFAFA',
          },
          '&.is-dragging': {
            borderColor: '#272D55',
            backgroundColor: '#F5F5F5',
          },
          '& .reorder-icon': {
            color: '#757575',
          },
        },
        //View Attribute
        '.attributeObj-background': {
          backgroundColor: '	rgb(240, 240, 240)',
        },

        // banner
        '.freeze-banner': {
          backgroundColor: '#00BFFF',
          color: '#FFFFFF',
        },

        '.advance-header-input .MuiOutlinedInput-root': {
          backgroundColor: '#FFFFFF',
          border: '1px solid #475467',
          '& .MuiInputBase-input': {
            color: '#000000',
          },
        },
        '.react-resizable-handle-se::after': {
          borderBottomColor: '#0000 !important',
          borderRightColor: '#0000 !important',
        },
        // LOG
        '.previousValue': {
          backgroundColor: '#FFF2F2',
          color: '#282828',
          borderLeft: '7px solid #F26673',
        },
        '.previousValueHead': {
          color: '#F26673',
        },
        '.modifiedValue': {
          backgroundColor: '#EEFFF5',
          color: '#282828',
          borderLeft: '7px solid #89C99F',
        },
        '.modifiedValueHead': {
          color: '#89C99F',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#FFFFFF',
          '&.app-header': {
            boxShadow: 'none',
            borderBottom: '1px solid #E2E4ED',
          },
        },
      },
    },

    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: '#FFFFFF',
          '&.ai-autofill-notification': {
            backgroundColor: '#FFFFFF',
          },
          '&.section-card': {
            '&:hover': {
              backgroundColor: '#F1F1F1',
            },
            '&.selected-card': {
              backgroundColor: '#F1F1F1',
            },
          },
          '&.ai-suggestion-card': {
            backgroundColor: 'transparent',
            borderLeftColor: '#8E55F9',
            '&.pending': {
              boxShadow: '0 1px 3px rgba(0, 0, 0, 0.13)',
              '&:hover': {
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.13)',
              },
            },
            '&.accepted': {
              borderLeftColor: '#058234',
              backgroundColor: '#EBFBF5',
            },
            '&.rejected': {
              borderLeftColor: '#E9E9E9',
              backgroundColor: '#FDEDEF',
            },
          },
          '&.activity-block-card': {
            borderColor: '#E3E6F0',
          },
        },
      },
    },
    // divider
    MuiDivider: {
      styleOverrides: {
        root: {
          broderColor: '#F4F4F4',
        },
      },
    },

    MuiDialog: {
      styleOverrides: {
        paper: {
          // backgroundColor: '#F3F5FF',
          // boxShadow: '0px 6px 12px rgba(132, 175, 239, 0.31)',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: 'rgba(174, 205, 252, 0.5)',
        },
        colorSecondary: {
          borderColor: '#84AFEF',
        },
        root: {
          '&:hover': {
            backgroundColor: '#AECDFC',
          },
          '&:focus': {
            backgroundColor: '#AECDFC',
          },
          '&:focus-visible': {
            outlineColor: '#000000',
          },
          '&.file-chip': {
            backgroundColor: '#FFFFFF',
            border: '1px solid',
            borderColor: '#BCBCBC',
            '&:hover': {
              backgroundColor: 'rgba(174, 205, 252, 0.2)',
            },
            '&.MuiChip-filled': {
              backgroundColor: '#AECDFC',
              '& .MuiChip-label': {
                color: '#272D55',
              },
              '& .MuiChip-deleteIcon': {
                color: '#272D55',
                '&:hover': {
                  color: '#272D55',
                },
              },
            },
          },
          '&.thread-chip': {
            backgroundColor: 'rgba(174, 205, 252, 0.5)',
            '& .MuiChip-label': {
              color: '#272D55',
            },
          },
          '&.impacted-chip': {
            backgroundColor: '#EB5757',
            '& .MuiChip-label': {
              color: '#FFFFFF',
            },
          },
          '&.not-impacted-chip': {
            backgroundColor: '#058234',
            '& .MuiChip-label': {
              color: '#FFFFFF',
            },
          },
          '&.user-chip': {
            backgroundColor: 'transparent !important',
            border: '1px solid',
            borderColor: '#9396AA',
            '& .MuiChip-label': {
              color: '#000000',
            },
            '& .MuiChip-icon': {
              color: '#9396AA',
            },
          },
          // Update Source Chip Color - used in overview page under other details
          '&.manual-chip': {
            backgroundColor: '#FEF0C7',
            '& .MuiChip-label': {
              color: '#B54708',
            },
          },
          '&.draft-chip': {
            backgroundColor: '#FEF0C7',
            '& .MuiChip-label': {
              color: '#B54708',
            },
          },
          '&.draft-values-count-chip': {
            backgroundColor: '#FEF0C7',
            border: 'none',
            borerRadius: '4px',
            '& .MuiChip-label': {
              color: '#B54708',
            },
            '& .MuiChip-icon': {
              color: '#B54708',
            },
            '&:hover': {
              backgroundColor: '#FEF0C7',
            },
          },
          '&.draft-state-header-chip': {
            backgroundColor: '#FEF0C7',
            border: '0.5px solid #B54708',
            '& .MuiChip-label': {
              color: '#B54708',
            },
            '& .MuiChip-icon': {
              color: '#B54708',
            },
            '&:hover': {
              backgroundColor: '#FFFAEB',
            },
          },
          '&.calculated-chip': {
            backgroundColor: '#D1FADF',
            '& .MuiChip-label': {
              color: '#05603A',
            },
          },
          '&.automation-chip': {
            backgroundColor: '#E4EEFF',
            '& .MuiChip-label': {
              color: '#0C3270',
            },
          },
          '&.default-chip': {
            backgroundColor: '#ECECEC',
            '& .MuiChip-label': {
              color: '#09090B',
            },
          },
          '&.bulk-chip': {
            backgroundColor: '#DBD1FA',
            '& .MuiChip-label': {
              color: '#551EF8',
            },
          },
          '&.overridden-chip': {
            backgroundColor: '#F0CCCF',
            '& .MuiChip-label': {
              color: '#C3000D',
            },
          },
          '&.filter-chip': {
            border: '1px solid #FFFFFF',
            backgroundColor: 'transparent',
            boxShadow: '0px 2px 6px rgba(0,0,0,0.15)',
            '& .MuiChip-label': {
              color: '#000000',
            },

            '&.active': {
              backgroundColor: '#FFFFFF',
              boxShadow: '0px 2px 6px rgba(0,0,0,0.15)',
            },
            '&:hover': {
              backgroundColor: '#F4F4F4',
            },
          },
          // advance Chips for headers like "Having" / "Where"
          '&.advance-header-chip': {
            border: '1px solid #BCBCBC',
            backgroundColor: '#FFFFFF',
            '& .MuiChip-label': {
              color: '#000000',
            },
            '&:hover, &:focus, &:active': {
              backgroundColor: '#FFFFFF',
            },
          },
          '&.ai-status-chip': {
            '&.accepted': {
              backgroundColor: 'rgba(5, 130, 52, 0.09)',
              color: '#1B7943',
              '& .MuiChip-icon': {
                color: '#1B7943',
              },
            },
            '&.rejected': {
              backgroundColor: 'rgba(227, 43, 43, 0.07)',
              color: '#E32B2B',
              '& .MuiChip-icon': {
                color: '#E32B2B',
              },
            },
          },
          '&.ai-badge-chip': {
            '&.pending': {
              backgroundColor: '#8E55F9',
              color: '#FFFFFF',
              '& .MuiChip-icon': {
                color: '#FFFFFF',
              },
              '& .MuiChip-label': {
                color: '#FFFFFF',
              },
            },
            '&.accepted': {
              backgroundColor: '#058234',
              color: '#FFFFFF',
              '& .MuiChip-icon': {
                color: '#FFFFFF',
              },
              '& .MuiChip-label': {
                color: '#FFFFFF',
              },
            },
          },
          '&.ai-section-chip': {
            '&.pending': {
              backgroundColor: 'rgba(142, 85, 249, 0.09)',
              '& .MuiChip-label': {
                color: '#8E55F9',
              },
            },
            '&.total': {
              backgroundColor: 'rgba(0, 0, 0, 0.08)',
              '& .MuiChip-label': {
                color: '#393939',
              },
            },
          },
          // Landscape ViewAll status chip — light mode
          '&.landscape-status-chip': {
            backgroundColor: '#D1FADF',
            border: '1px solid #05603A',
            '& .MuiChip-label': {
              color: '#05603A',
            },
            '&:hover': {
              backgroundColor: '#D1FADF',
            },
          },
          '&.MuiChip-colorPrimary > .MuiChip-deleteIcon': {
            color: '#272D55',
            '&:hover': {
              color: '#272D55',
            },
          },
        },
        label: {
          color: '#272D55',
        },
      },
      variants: [
        {
          props: { variant: 'outlined' },
          style: {
            borderColor: '#D8DAE5',
            backgroundColor: '#F1F3F4',
            '&:hover': {
              backgroundColor: '#F1F3F4',
            },
          },
        },
        {
          props: { variant: 'customFilter' },
          style: {
            borderColor: '#BCBCBC',
            color: '#000000',
            backgroundColor: 'transparent',
            '&:hover': {
              borderColor: '#BCBCBC',
              backgroundColor: 'transparent',
            },
            '& .MuiChip-deleteIcon': {
              color: '#000000',
              borderColor: '#000000',
              '&:hover': {
                color: '#000000',
                backgroundColor: 'transparent',
              },
            },
          },
        },
      ],
    },
    MuiBackdrop: {
      styleOverrides: {
        root: {
          '&.backdrop-blur': {
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
          },
        },
      },
    },

    MuiTable: {
      styleOverrides: {
        root: {
          borderRadius: '0px !important',
          border: '1px solid #E2E8F0',
          backgroundColor: '#FFFFFF',
        },
      },
    },

    MuiTableCell: {
      styleOverrides: {
        head: {
          backgroundColor: '#EAECF0 !important',
          color: '#282828 !important',
          borderBottom: '1px solid #D0D5DD',
          '&:hover': {
            backgroundColor: '#EAECF0 !important',
          },
          '& .FilterIcon svg': {
            color: '#282828 !important',
          },
          '&.list-table-header': {
            backgroundColor: '#EAECF0 !important',
            color: '#282828 !important',
            '&:hover': {
              backgroundColor: '#EAECF0 !important',
            },

            '& .MuiCheckbox-root': {
              color: '#282828',
            },
            '& .Mui-checked': {
              color: '#272D55',
            },
            '& .MuiTableSortLabel-root': {
              backgroundColor: 'transparent',
              '& svg': {
                fill: '#334155 !important',
              },
            },
          },
        },

        root: {
          // borderColor: THEME_PALETTE.secondary.dark,
          borderRadius: '0px !important',
          background: 'transparent',
          borderBottomColor: '#E3E6F0',
          '&.MuiTablePagination-root': {
            background: 'transparent',
          },
          '&.list-table-cell': {
            borderBottomColor: '#E3E6F0',
          },
        },
        sizeMedium: {
          '&.list-table-cell': {
            borderColor: '#E3E6F0',
          },
        },

        sizeSmall: {
          borderColor: '#E3E6F0',
          borderRightColor: '#E3E6F0',
          '&:hover': {
            backgroundColor: '#F8FAFC',
          },
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: '#F3F3F3 !important',
          borderColor: '#E4E4E7',
          '& .MuiTableSortLabel-root': {
            backgroundColor: 'transparent',
            '& svg': {
              fill: '#64748B !important',
            },
          },

          '&.MuiTableHead-bg th': {
            backgroundColor: '#F3F3F3 !important',
            color: '#101828 !important',

            '&:hover': {
              backgroundColor: '#F3F3F3 !important',
            },
          },
        },
      },
    },
    MuiTableSortLabel: {
      styleOverrides: {
        root: {
          color: '#282828 !important',
          '&:hover': {
            color: '#1F2937 !important',
          },
          '&.Mui-active': {
            color: '#1F2937 !important',
          },
        },
        icon: {
          color: '#94A3B8 !important',
        },
      },
    },
    MuiTableBody: {
      styleOverrides: {
        root: {
          borderColor: '#E3E6F0',
        },
      },
    },

    MuiTableRow: {
      styleOverrides: {
        root: {
          transition: 'background-color 0.2s ease',
          '&:focus-visible': {
            border: `2px solid rgba(39, 45, 85, 0.2)`,
          },
          '&.Mui-selected': {
            backgroundColor: '#EEF4FF !important',
            '&:hover': {
              backgroundColor: '#E8F0FF !important',
            },
          },
          '&:hover': {
            backgroundColor: '#F8FAFC !important',
          },
        },
      },
    },

    MuiTablePagination: {
      styleOverrides: {
        root: {
          borderTop: '1px solid #E2E8F0',
          backgroundColor: '#FFFFFF',
          '&:focus-visible': {
            border: `2px solid rgba(39, 45, 85, 0.2)`,
          },
          '& .MuiTablePagination-toolbar': {
            '& select': {
              background: 'transparent',
            },
          },
        },
        select: {
          // background: '#FFFFFF',
          '&:focus-visible': {
            outlineColor: '#000000',
          },
        },
        actions: {
          '& button:focus-visible': {
            outlineColor: '#000000',
          },
        },
        toolbar: {
          // background: '#F3F5FF',
        },
      },
    },
    MuiPaginationItem: {
      styleOverrides: {
        previousNext: {
          background: '#FFFFFF !important',
        },
        root: {
          '&:focus-visible': {
            outlineColor: '#000000 !important',
          },
          '&.Mui-selected': {
            backgroundColor: '#D0D5DD !important',
            color: '#101828 !important',
          },
        },
      },
    },

    MuiLinearProgress: {
      styleOverrides: {
        root: {
          '&.MuiLinearProgress-colorPrimary > .MuiLinearProgress-bar': {
            backgroundColor: '#272D55 !important',
          },
          '&.ai-progress': {
            backgroundColor: 'rgba(142, 85, 249, 0.08) !important',
            '& .MuiLinearProgress-bar': {
              backgroundColor: '#8E55F9',
              transition: 'transform 0.4s ease',
            },
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: '#393939 !important',
          '&.Mui-focused': {
            color: '#393939 !important',
          },
          '&.Mui-error': {
            color: '#C21919 !important',
          },
          '&.Mui-disabled': {
            color: '#9396AA !important',
          },
          '& .MuiInputLabel-asterisk': {
            color: '#E32B2B !important',
          },
          '& .MuiFormLabel-asterisk': {
            color: '#E32B2B !important',
          },
        },
        asterisk: {
          color: '#E32B2B !important',
          '&.Mui-error': {
            color: '#C21919',
          },
        },
      },
    },

    MuiFormControl: {
      styleOverrides: {
        root: {
          '& .MuiInputLabel-root': {
            color: '#000',
            '&.Mui-error': {
              color: '#C21919 !important',
            },
            '& .MuiTypography-root': {
              color: '#000',
            },
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiInputLabel-root': {
            color: '#393939',
          },
          '& .MuiInputLabel-shrink': {
            color: '#000',
          },
          '& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline':
            {
              borderColor: 'rgba(0, 0, 0, 0.8)',
            },
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          borderColor: '#E3E6F0',
          '&.vertical-tabs': {
            borderColor: '#E9E9E9',
          },
          '&.horizontal-tabs-vertical-style': {
            borderColor: '#E9E9E9',
          },
          '&.ai-filter-tabs': {
            borderColor: '#E9E9E9',
          },
        },
        indicator: {
          boxShadow: '0px -2px 14px rgba(39, 45, 85, 0.24)',
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          color: '#393939', // Default color for non-selected tabs
          '&:focus-visible': {
            outlineColor: '#000000',
          },
          '&.Mui-selected': {
            color: '#272D55', // Color for selected tabs
          },
          '&.vertical-tab-with-icons': {
            color: '#272D55',
            borderColor: '#E9E9E9',
            '&:hover': {
              backgroundColor: '#F0F0F0',
            },
            '&.Mui-selected': {
              color: '#272D55',
              backgroundColor: 'rgba(39, 45, 85, 0.2)',
            },
          },
          '&.vertical-tab': {
            color: '#393939',
            borderColor: '#E9E9E9',
            '&:hover': {
              backgroundColor: '#F0F0F0',
            },
            '&.Mui-selected': {
              color: '#272D55',
              backgroundColor: 'rgba(39, 45, 85, 0.2)',
            },
          },
          '&.horizontal-tab-vertical-style': {
            color: '#393939',
            borderColor: '#E9E9E9',
            '&:hover': {
              backgroundColor: '#F0F0F0',
            },
            '&.Mui-selected': {
              color: '#393939',
              backgroundColor: 'rgba(39, 45, 85, 0.2)',
            },
          },
          '&.ai-filter-tab': {
            color: '#393939',
            borderLeftColor: '#E9E9E9',
            '&:hover': {
              backgroundColor: 'rgba(142, 85, 249, 0.04)',
            },
            '&.Mui-selected': {
              color: '#8E55F9',
              borderBottomColor: '#8E55F9',
            },
            '&.ai-filter-tab-success.Mui-selected': {
              color: '#058234',
              borderBottomColor: '#058234',
            },
            '&.ai-filter-tab-error.Mui-selected': {
              color: '#E32B2B',
              borderBottomColor: '#E32B2B',
            },
          },
          '&.variant-chip-tab': {
            backgroundColor: '#C0D9FF4D',
            color: '#272D55',

            '&:hover': {
              backgroundColor: '#AECDFC',
            },
            '&.Mui-selected': {
              backgroundColor: '#AECDFC',
            },
          },
          '&.custom-tab': {
            color: '#000000',
            '&.Mui-selected': {
              background: '#FFFFFF',
              color: '#000000',
            },
          },
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          '&:focus-visible': {
            outlineColor: '#000000',
          },
          '&.Mui-disabled': {
            color: '#E0E0E0',
          },
          '&.Mui-disabled svg *': {
            fill: '#E0E0E0',
          },
          '&.app-header-icon-btn': {
            color: '#3D4253',
            '&:hover': {
              backgroundColor: '#EFF0F6',
              color: '#272D55',
            },
          },
          '&.ai-action-accept': {
            borderColor: '#8E55F9',
            color: '#8E55F9',
            '&:hover': {
              backgroundColor: '#7040D4',
              borderColor: '#7040D4',
              color: '#FFFFFF',
            },
          },
          '&.ai-action-reject': {
            borderColor: '#E32B2B',
            color: '#E32B2B',
            '&:hover': {
              backgroundColor: '#E32B2B',
              color: '#FFFFFF',
            },
          },
          '&.ai-action-undo': {
            borderColor: '#D08329',
            color: '#D08329',
            '&:hover': {
              backgroundColor: '#D08329',
              color: '#FFFFFF',
            },
          },
          '&.ai-action-accept-sm': {
            borderColor: '#8E55F9',
            color: '#8E55F9',
            '&:hover': {
              backgroundColor: '#7040D4',
              color: '#FFFFFF',
            },
          },
          '&.ai-action-reject-sm': {
            borderColor: '#E32B2B',
            color: '#E32B2B',
            '&:hover': {
              backgroundColor: '#E32B2B',
              color: '#FFFFFF',
            },
          },
          '&.ai-action-undo-sm': {
            borderColor: '#D08329',
            color: '#D08329',
            '&:hover': {
              backgroundColor: '#D08329',
              color: '#FFFFFF',
            },
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          '&:focus-visible': {
            outlineColor: '#000000',
          },
          '&.help-support-pagination-button': {
            border: '1px solid transparent',
            ':hover': {
              border: `1px solid #272D55`,
              boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px !important',
            },
            boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px !important',
          },
          '&.Mui-SearchPaginationAction': {
            backgroundColor: '#272D55',
            color: '#FFFFFF',
            '&:hover': {
              backgroundColor: '#1B1F3B',
            },
          },
          '&.automation-lineage-view-button': {
            color: '#0C3270',
            '&:hover': {
              backgroundColor: 'transparent',
              color: '#0C3270',
            },
          },
          '&.MenuButtons': {
            color: '#3D4253',
            '&:hover': {
              backgroundColor: '#F4F5FA',
              color: '#272D55',
            },
          },
          '&.filledButton': {
            backgroundColor: '#DFDFDF80',
            '&:hover': {
              backgroundColor: '#F1F3F4',
            },
            textTransform: 'none',
          },
          '&.ai-upload-button': {
            borderColor: '#8E55F9',
            color: '#8E55F9',
            '&:hover': {
              borderColor: '#7040D4',
              backgroundColor: 'rgba(142, 85, 249, 0.06)',
            },
          },
          '&.ai-autofill-trigger-button': {
            borderColor: '#8E55F9',
            color: '#8E55F9',
            '&:hover': {
              borderColor: '#7040D4',
              backgroundColor: 'rgba(142, 85, 249, 0.04)',
            },
          },
          '&.ai-dialog-button': {
            '&.accept': {
              backgroundColor: '#8E55F9',
              color: '#FFFFFF',
              '&:hover': {
                backgroundColor: '#7040D4',
              },
            },
          },
          '&.ai-action-pill': {
            '&.accept': {
              backgroundColor: '#8E55F9',
              color: '#FFFFFF',
              '&:hover': {
                backgroundColor: '#7040D4',
              },
            },
            '&.reject': {
              borderColor: '#E32B2B',
              color: '#E32B2B',
              '&:hover': {
                borderColor: '#E32B2B',
                backgroundColor: 'rgba(227, 43, 43, 0.06)',
              },
            },
            '&.undo': {
              borderColor: '#D08329',
              color: '#D08329',
              '&:hover': {
                borderColor: '#D08329',
                backgroundColor: 'rgba(208, 131, 41, 0.07)',
              },
            },
          },
          '&.log-filter-standalone-btn': {
            borderColor: '#E0E0E0',
            color: '#282828',
            '&:hover': {
              backgroundColor: '#E3E3E3',
              borderColor: '#E3E3E3',
              color: '#282828',
            },
            '&.active': {
              backgroundColor: '#E3E3E3',
              borderColor: '#E3E3E3',
              color: '#282828',
            },
          },
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          color: '#272D55',
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: '#272D55',
          '&.Mui-focusVisible': {
            backgroundColor: '#D9D9D9',

            '& .MuiSvgIcon-root': {
              backgroundColor: 'white',
            },
          },
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        track: {
          backgroundColor: '#aaa',
          '&.Mui-checked': {
            backgroundColor: '#1976d2 !important',
          },
        },
        thumb: {
          borderColor: '#272D55 !important',
          '&.Mui-checked': {
            backgroundColor: '#272D55 !important',
          },
        },
        input: {
          '&:focus-visible + .MuiSwitch-thumb': {
            outlineColor: '#000000',
          },
        },
      },
    },
    MuiAvatar: {
      styleOverrides: {
        root: {
          // Default avatar styling
          backgroundColor: '#272D55',
          color: '#FFFFFF',
        },
      },
    },
    MuiList: {
      styleOverrides: {
        root: {
          backgroundColor: 'transparent',
        },
      },
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          borderBottomColor: '#84AFEF',
          '& .MuiListItemButton-root': {
            '& .list-item-button-hover-actions-right': {
              backgroundImage:
                'linear-gradient(269.82deg, #DDE9FF 68.25%, rgba(200, 222, 255, 0.1) 87.71%)',
            },
            '&.selected': {
              backgroundColor: '#F4F4F5',
            },
            '&:hover': {
              backgroundColor: '#F4F4F5',
            },
          },
          '&.explorer-list-item': {
            '&.active': {
              backgroundColor: 'rgba(39, 45, 85, 0.2)',
            },
            '&.inactive': {
              backgroundColor: '#FFFFFF',
            },
            '&.isOverAndCanDrop': {
              outline: '1px solid #272D55',
            },
            '&:hover': {
              backgroundColor: 'rgba(39, 45, 85, 0.2)',
            },
          },
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            backgroundColor: '#E4EEFF !important',
          },
          '&.Mui-selected:hover': {
            backgroundColor: '#E4EEFF !important',
          },
          '&:hover': {
            backgroundColor: '#E4EEFF !important',
          },
        },
      },
    },
    AttributeList: {
      '&.MuiListItemButton-root': {
        padding: '0px',
        '&:hover': {
          backgroundColor: 'none',
        },
      },
      '&.MuiListItem-root': {
        border: '1px solid #D2D2D2',
      },
      styleOverrides: {
        listItem: {
          border: '1px solid #D2D2D2',
          borderRadius: '4px',
        },
      },
    },

    MuiSelect: {
      styleOverrides: {
        select: {
          backgroundColor: '#ffffff ',
        },
        icon: {
          color: '#272D55 !important',
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        asterisk: {
          color: '#E32B2B !important',
          '&.Mui-error': {
            color: '#C21919',
          },
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          color: '#C21919',
          '&.Mui-error': {
            color: '#C21919',
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderColor: '#BCBCBC !important',
          backgroundColor: '#FFFFFF !important',
          '& fieldset': {
            border: 'none',
          },
          '&:hover': {
            borderColor: '#BCBCBC !important',
          },
          '&.Mui-focused': {
            borderColor: '#141E62 !important',
          },
          '&.Mui-error': {
            borderColor: '#C21919 !important',
            '& .MuiFormHelperText-root': {
              color: '#C21919 !important',
            },
          },
          '&.Mui-disabled': {
            color: '#E9E9E9 !important',
          },
        },
        input: {
          color: '#393939 !important',
          '&.Mui-disabled': {
            WebkitTextFillColor: '#9396AA',
            color: '#9396AA',
          },
          '&::placeholder': {
            color: '#525252 !important',
          },
        },
      },
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          backgroundColor: '#FFFFFF !important',
        },
        input: {
          '&:-webkit-autofill': {
            WebkitBoxShadow: '0 0 0 1000px #FFFFFF inset',
            WebkitTextFillColor: '#000000',
            transition: 'background-color 5000s ease-in-out 0s',
          },
        },
      },
    },
    MuiSlider: {
      styleOverrides: {
        root: {
          color: '#272D55',
        },
        track: {
          backgroundColor: '#272D55',

          borderColor: '#272D55',
        },
        rail: {
          backgroundColor: '#FFFFFF',

          borderColor: '#272D55',
        },
        valueLabel: {
          color: '#FFFFFF',
          background: '#272D55',
        },
        mark: {
          background: '#272D55 !important',
        },
        markLabel: {
          color: '#272D55 !important',
        },
        thumb: {
          '&:hover': {
            boxShadow: `0px 0px 0px 15px rgba(174, 205, 252, 0.5) !important`,
          },
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          '&.ai-review-drawer': {
            borderLeft: '1px solid #E9E9E9',
            boxShadow:
              '-4px 0 24px rgba(0, 0, 0, 0.12), -1px 0 6px rgba(0, 0, 0, 0.06)',
          },
          '&.filter-drawer': {
            borderLeft: '1px solid #E9E9E9',
            boxShadow:
              '-4px 0 24px rgba(0, 0, 0, 0.12), -1px 0 6px rgba(0, 0, 0, 0.06)',
          },
        },
      },
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          backgroundColor: 'rgba(174, 205, 252, 0.4)',
          '&.permission-accordion': {
            backgroundColor: 'rgba(174, 205, 252, 0.1)',
          },

          '&:before': {
            backgroundColor: 'transparent !important',
          },
          '&.job-queue-accordion': {
            borderColor: '#BCBCBC',
            '& .MuiAccordionDetails-root': {
              backgroundColor: 'transparent',
            },
          },
          '&.job-queue-accordion-read': {
            backgroundColor: '#FFFFFF',
          },
          '&.job-queue-accordion-unread': {
            backgroundColor: 'rgba(174, 205, 252, 0.2)',
          },
          '&.automation-lineage-details-accordion': {
            backgroundColor: '#FFFFFF',
            border: '1px solid #E3E6F0',
            boxShadow: 'none',
            color: '#282828',
            '& .MuiAccordionSummary-root': {
              backgroundColor: '#FFFFFF',
              borderBottom: '1px solid #E3E6F0',
            },
          },
          '&.ai-section-accordion': {
            backgroundColor: 'transparent',
            '& .MuiAccordionSummary-root.ai-section-summary': {
              backgroundColor: '#F9F9F9F2',
              borderBottomColor: '#E9E9E9',
              borderLeftColor: '#E9E9E9',
              border: `1px solid #E0E0E0`,
              borderRadius: '4px',
              '&:hover': {
                backgroundColor: 'rgba(142, 85, 249, 0.03)',
              },
              '&:focus-visible': {
                outline: '2px solid #8E55F9',
                outlineOffset: '-2px',
              },
            },
            '&.has-pending .MuiAccordionSummary-root.ai-section-summary': {
              borderLeftColor: '#8E55F9',
            },
          },
          '&.query-dialog-accordion': {
            backgroundColor: '#F8FAFC',
            border: '1px solid #E2E8F0',
            borderRadius: '8px',
            marginBottom: '16px',
            overflow: 'hidden',
            boxShadow: 'none',
            '&:before': {
              display: 'none',
            },
            '& .MuiAccordionSummary-root': {
              backgroundColor: '#F3F3F3',
              borderBottom: '1px solid #E3E6F0',
              height: '36px',
              '& .MuiAccordionSummary-content': {
                margin: 0,
              },
            },
            '& .MuiAccordionSummary-root.Mui-expanded': {
              borderBottom: '1px solid #E3E6F0',
              height: '36px',
            },
            '& .MuiAccordionDetails-root': {
              padding: '16px 24px 24px',
              display: 'flex',
              flexDirection: 'column',
              gap: '16px',
            },
          },
        },
      },
    },
    MuiAccordionDetails: {
      styleOverrides: {
        root: {
          backgroundColor: '#FFFFFF',
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          background: '#FFFFFF',
          color: '#282828 !important',
          '& .MuiTypography-root': {
            color: '#282828 !important',
          },
          '& .landscape-relation-tooltip .MuiTypography-body5': {
            color: '#616E85 !important',
          },
          '& .landscape-title-card .MuiTypography-body5': {
            color: '#616E85 !important',
          },
          boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          '&:hover': '#E3E3E3',
        },
      },
    },
    MuiGrid: {
      styleOverrides: {
        root: {
          '&.summary-card': {
            backgroundColor: '#FFFFFF',
            borderRadius: '4px',
          },
        },
      },
    },
    SolyticsEditorToolbar: {
      styleOverrides: {
        baseButton: {
          color: '#000000',
          backgroundColor: 'transparent',
          ':hover': {
            backgroundColor: 'rgba(39, 45, 85, 0.1)',
          },
          '&.Mui-disabled': {
            color: 'rgba(0, 0, 0, 0.2)',
          },
        },
        toggleButton: {
          color: '#111111',
          '.MuiTypography-root': {
            color: '#111111',
          },
          '&.is-active': {
            backgroundColor: 'rgba(39, 45, 85, 0.2)',
            color: '#000000',
            '.MuiTypography-root': {
              color: '#000000',
            },
          },
          ':hover': {
            backgroundColor: 'rgba(39, 45, 85, 0.1)',
          },
        },
        headingDropdown: {
          '.MuiSelect-select': {
            backgroundColor: 'transparent',
          },
          '.MuiOutlinedInput-root': {
            backgroundColor: 'transparent',
            ':hover': {
              backgroundColor: 'rgba(39, 45, 85, 0.1)',
            },
          },
        },
        ToolbarPaper: {
          boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
        },
        ToolbarMenu: {
          '.MuiPaper-root': {
            boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
          },
        },
        ToolbarMenuItem: {},
        ToolbarVerticalDivider: {
          backgroundColor: '#E7E4E2',
        },
      },
    },
    BubbleMenuContainer: {
      styleOverrides: {
        root: {
          backgroundColor: '#FFFFFF',
          boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
        },
      },
    },
    BubbleMenuButton: {
      styleOverrides: {
        root: {
          color: '#000000',
          backgroundColor: 'transparent',
          ':hover': {
            backgroundColor: 'rgba(39, 45, 85, 0.1)',
          },
        },
      },
    },
    TemplatesSectionsAndAttributes: {
      styleOverrides: {
        section: {
          '&.isOverAndOrdering': {
            borderColor: '#272D55',
          },
          '&.isOrdering': {
            ':hover': {
              borderColor: '#272D55',
            },
          },
        },
      },
    },
    BulkTransitionHistory: {
      styleOverrides: {
        statusCircle: {},
        listItemContainer: {
          '&:hover': {
            background: 'rgba(39, 45, 85, 0.1)',
          },
        },
        itemWrapper: {
          background: 'rgba(39, 45, 85, 0.1)',
        },
        list: {
          bgcolor: '#F9F9F9',
        },
        deletedModelBox: {
          '&:hover': {
            background: 'rgba(39, 45, 85, 0.1)',
          },
        },
      },
    },
    WorkflowSidebar: {
      styleOverrides: {
        conditionalCard: {
          backgroundColor: 'rgba(39, 45, 85, 0.31)',
        },
        conditionalStack: {
          borderColor: '#272D55',
        },
        cardTypography: {
          color: '#272D55',
        },
        nodeCard: {
          borderColor: '#272D55',
          backgroundColor: '#FFFFFF',
        },
        nodeIconBox: {
          backgroundColor: '#FFFFFF',
        },
        nodeContentBox: {
          backgroundColor: '#FFFFFF',
        },
        nodeTypography: {
          color: '#272D55',
        },
      },
    },
    FormulaSidebar: {
      styleOverrides: {
        nodeCard: {
          borderColor: '#272D55',
          backgroundColor: '#FFFFFF',
        },
        container: {
          backgroundColor: '#FFFFFF',
          boxShadow: '-4px 0px 4px rgba(0, 0, 0, 0.25)',
        },
        buttonContainer: {
          backgroundColor: '#FFFFFF',
        },
        nodesContainer: {
          backgroundColor: '#FFFFFF',
        },
      },
    },
    Login: {
      styleOverrides: {
        SuccessAlert: {
          backgroundColor: '#058234',
          color: '#FFFFFF',
        },
        ErrorAlert: {
          backgroundColor: '#EB5757',
          color: '#FFFFFF',
        },
      },
    },
    MultiUploadFormDropzoneBox: {
      styleOverrides: {
        root: {
          border: `1px dashed #272D55`,
        },
      },
    },
  },
};

export const lightTheme = LIGHT_THEME;
export default createTheme(merge(cloneDeep(baseTheme), LIGHT_THEME));
